<template>
  <div id="triplist">
    <b-container class="bv-example-row">
      <div style="padding-top: 2%">
        <div class="container-title-page">
          <div class="box-text-content-title">
            <h2>MES RÉSERVATIONS</h2>
            <p>
              <strong
                >Vous avez hâte de partir? Vous trouverez tous les documents
                relatifs à vos réservations et tout ce dont vous avez besoin
                pour bien préparer votre voyage!</strong
              >
            </p>
          </div>
        </div>
        <!-- <div class="circles_page">
          <img class="little_circle" src="../assets/little_circle.svg" />
          <img class="big_circle" src="../assets/big_circle.svg" />
        </div> -->
        <div class="container-tabs-menu center-text">
          <a
            :class="classSelect.reservation"
            @click="changeMode('reservation')"
          >
            <img src="../assets/earth.svg" />
            Réservations ACTIVES
          </a>
          <a :class="classSelect.attente" @click="changeMode('attente')">
            <img src="../assets/hour-glass.svg" />
            Réservations EN ATTENTE
          </a>
        </div>
        <div v-if="mode === 'reservation'">
          <div
            class="contents-profils-form active-tabs"
            v-for="(trip, index) in triplist.active"
            :key="'active-' + index"
          >
            <TripCard :trip="trip" :isActive="1" />
            <br />
          </div>
          <div
            class="contents-profils-form active-tabs"
            v-if="!triplist.active || triplist.active.length === 0"
          >
            <p class="empty">Vous n'avez pas de voyage actif.</p>
          </div>
        </div>
        <div v-if="mode === 'attente'">
          <div
            class="contents-profils-form active-tabs"
            v-for="(trip, index) in triplist.toRegister"
            :key="'toRegister-' + index"
          >
            <TripCard :trip="trip" :isActive="2" />
            <br />
          </div>
          <div
            class="contents-profils-form active-tabs"
            v-if="!triplist.toRegister || triplist.toRegister.length === 0"
          >
            <p class="empty">Vous n'avez pas de voyage en attente.</p>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
import TripCard from "@/components/TripCard";
import { mapState, mapActions } from "vuex";
export default {
  name: "TripList",
  components: {
    TripCard,
  },
  data: () => ({
    classSelect: {
      reservation: "item-tabs-menu active-tabs",
      attente: "item-tabs-menu",
    },
    mode: "reservation",
  }),
  computed: {
    ...mapState({
      triplist: (state) => state.triplist.list,
    }),
  },
  methods: {
    ...mapActions(["getTripList"]),
    changeMode(type) {
      this.mode = type;
      this.classSelect.attente = "item-tabs-menu";
      this.classSelect.reservation = "item-tabs-menu";
      this.classSelect[type] = "item-tabs-menu active-tabs";
    },
  },
  mounted() {
    //do something after mounting vue instance
    this.getTripList(2);
    this.getTripList(1);
  },
};
</script>
<style lang="css" scoped>
.container {
  padding-bottom: 10px;
}
</style>
